import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class TestimonyActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Web/Testimony/TestimonyBrowser")
	}

	render() {
		return (
			<Activity 
				name="Testimony"
				RenderedComponent={this.RenderedComponent}
                context="Testimony"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(TestimonyActivity)
